import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12212135")

_pushScopeId("data-v-12212135")
const _hoisted_1 = { class: "ExpressInvoiceForm" }
const _hoisted_2 = { class: "ExpressInvoiceForm__header" }
const _hoisted_3 = { class: "ExpressInvoiceForm__title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Удалить ")
const _hoisted_5 = { class: "ExpressInvoiceForm__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_button = _resolveComponent("s-button")!
  const _component_express_multi_tasks = _resolveComponent("express-multi-tasks")!
  const _component_express_multi_items_form = _resolveComponent("express-multi-items-form")!
  const _component_express_multi_items = _resolveComponent("express-multi-items")!
  const _component_express_additional_data = _resolveComponent("express-additional-data")!
  const _component_express_setted_additional_data = _resolveComponent("express-setted-additional-data")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, "Накладная №" + _toDisplayString(_ctx.index), 1),
      _createVNode(_component_s_button, {
        disabled: _ctx.disabled,
        class: "black",
        onClick: _ctx.emitDelete
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("p", null, "Получатель: " + _toDisplayString(_ctx.invoice.title), 1),
      _createVNode("p", null, _toDisplayString(_ctx.invoice.full_address), 1),
      _createVNode(_component_express_multi_tasks, {
        disabled: _ctx.disabled,
        tasks: _ctx.tasks,
        loading: _ctx.isTasksLoading,
        failed: _ctx.isTasksFailed,
        "selected-tasks-ids": _ctx.invoice.tasks.map((task) => task.id),
        "is-tariff-selected": _ctx.isTariffSelected,
        "selected-tariff-price": _ctx.selectedTariffPrice,
        onReload: _ctx.emitReloadTasks,
        onSelect: _ctx.emitSelectTask,
        onUnselect: _ctx.emitUnselectTask
      }, null, 8, ["disabled", "tasks", "loading", "failed", "selected-tasks-ids", "is-tariff-selected", "selected-tariff-price", "onReload", "onSelect", "onUnselect"]),
      _createVNode(_component_express_multi_items_form, {
        disabled: _ctx.disabled,
        onAddItem: _ctx.emitAddItem
      }, null, 8, ["disabled", "onAddItem"]),
      (_ctx.items.length > 0)
        ? (_openBlock(), _createBlock(_component_express_multi_items, {
            key: 0,
            disabled: _ctx.disabled,
            items: _ctx.items,
            onRemoveItem: _ctx.emitRemoveItem
          }, null, 8, ["disabled", "items", "onRemoveItem"]))
        : _createCommentVNode("", true),
      (_ctx.isAdditionalData)
        ? (_openBlock(), _createBlock(_component_express_additional_data, {
            key: 1,
            class: "ExpressMultiTemplate__block",
            disabled: _ctx.disabled,
            "receiver-idx": _ctx.index - 1,
            onSubmit: _ctx.emitSubmitAdditionalData
          }, null, 8, ["disabled", "receiver-idx", "onSubmit"]))
        : (_openBlock(), _createBlock(_component_express_setted_additional_data, {
            key: 2,
            class: "ExpressMultiTemplate__block",
            "extra-info": _ctx.extraInfo,
            "amount-to-accept-payment": _ctx.amountToAcceptPayment,
            "verification-type": _ctx.verificationType,
            "verification-invoice-number": _ctx.verificationInvoiceNumber,
            disabled: _ctx.disabled,
            "receiver-idx": _ctx.index - 1,
            onReset: _ctx.emitResetAdditionalData
          }, null, 8, ["extra-info", "amount-to-accept-payment", "verification-type", "verification-invoice-number", "disabled", "receiver-idx", "onReset"]))
    ])
  ]))
})